import { selectCurrentHotelName } from 'accessors'
import ErrorIcon from 'components/ReusableComponents/BackgroundImage/ErrorIcon'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import MediaUploader from 'features/ManageCampaigns/MediaUploader'
import TextArea from 'features/ManageCampaigns/TextArea'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import styles from './EditCampaign.module.scss'

function getBaseTags(hotelName) {
  return [
    {
      id: '__hotelName__',
      display: 'hotelName',
      code: '@[hotelName](__hotelName__)',
      length: hotelName.length
    },
    {
      id: '__guestName__',
      display: 'guestName',
      code: '@[guestName](__guestName__)',
      length: 8
    },
    {
      id: '__checkoutDate__',
      display: 'checkoutDate',
      length: 11
    }
  ]
}

const urlRegex = /^(http|https)?:\/\/\S+/i

const MainTemplate = ({
  messageTemplate,
  onTextChange,
  messageMedia,
  setMessageMedia,
  usedAllTags,
  setUsedAllTags,
  mediaTag,
  requiredTagIds,
  isMediaRequired,
  customUrl,
  setCustomUrl,
  isCustomUrlAllowed
}) => {
  const hotelName = useSelector(selectCurrentHotelName)

  function handleChange(text) {
    onTextChange(text)
  }

  function handleUpdateUsedTags(usedTags) {
    const isAllTagsUsed = requiredTagIds.every(tag =>
      usedTags.find(usedTag => usedTag.id === tag)
    )
    setUsedAllTags(isAllTagsUsed)
  }

  const [useCustomUrl, setUseCustomUrl] = useState(customUrl !== null)

  const isCustomUrlValid = customUrl ? !!customUrl.match(urlRegex) : false

  function handleChangeCustomUrl(e) {
    setUseCustomUrl(e.target.checked)
    if (!e.target.check) {
      setCustomUrl(null)
    }
  }

  return (
    <div className={styles.accordionContent}>
      <div className={styles.textAreaHolder}>
        <span className={styles.datepickerLabel}>Message text</span>
        <div className={styles.textAreaBox}>
          <TextArea
            baseTags={getBaseTags(hotelName) || []}
            previewPrefix="123"
            value={messageTemplate}
            handleUpdateUsedTags={handleUpdateUsedTags}
            handleChange={handleChange}
            isErred={!usedAllTags}
            requiredTagIds={requiredTagIds}
          />
        </div>
      </div>
      {isCustomUrlAllowed && (
        <div className={styles.customUrlSection}>
          <Toggle
            label={'Use a custom invite link'}
            checked={useCustomUrl}
            handleChange={handleChangeCustomUrl}
            className={styles.customLinkToggle}
          />
          {useCustomUrl && (
            <div>
              <TextInput
                className={styles.customReviewLinkInput}
                autoFocus
                placeholder="https://"
                value={customUrl || ''}
                onChange={e => setCustomUrl(e.target.value)}
                valid={isCustomUrlValid}
              />
              {customUrl && !isCustomUrlValid && (
                <p className={styles.customRevieLinkError}>
                  Enter a valid link starting with http or https
                </p>
              )}
            </div>
          )}
        </div>
      )}
      <span className={styles.datepickerLabel}>Media (optional)</span>
      {!messageMedia && isMediaRequired && (
        <div className={styles.recommendation}>
          <ErrorIcon />
          <p>
            Adding an image or video is <strong>strongly recommended</strong> to get the
            best results from text blasts.
          </p>
        </div>
      )}
      <MediaUploader
        hasTitle={false}
        selectedMedia={messageMedia}
        setSelectedMedia={setMessageMedia}
        removeSelectedMedia={() => setMessageMedia(null)}
        acceptedFileTypes={['image/*', 'application/pdf']}
        previewCount={4}
        mediaTag={mediaTag}
      />
    </div>
  )
}

export default MainTemplate
